import useSWR from 'swr';
import { TypeSubscriberShopCollection } from '@/lib/api/productCatalog/types';
import { TypeSubscriptionRecord } from '@/lib/api/subscriptionManager/types';
import { usePathname } from 'next/navigation';

interface UseSubscriberShopProps {
  userUuid: string;
  authToken: string;
  locale: string;
  filterBy?: string[];
}

type SubscriberShopData = {
  collections?: TypeSubscriberShopCollection[];
  subscriptions?: TypeSubscriptionRecord[];
};

interface UseSubscriberShopReturn {
  data?: SubscriberShopData;
  isLoading: boolean;
  error?: Error;
}

export const useSubscriberShop = ({
  userUuid,
  authToken,
  locale,
  filterBy,
}: UseSubscriberShopProps): UseSubscriberShopReturn => {
  const pathName = usePathname();
  const fetcher = () =>
    fetch('/api/account-settings/subscriberShop', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userUuid,
        authToken,
        locale,
        filterBy,
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Failed to fetch data');
        }
        return res.json();
      })
      .then((data) => {
        if (filterBy) {
          data.collections = data.collections.filter(
            (collection: TypeSubscriberShopCollection) =>
              filterBy.includes(collection.anchor),
          );
        }
        return data;
      });

  const slugKey = pathName?.split('/').pop() || 'sub-collections';

  return useSWR<SubscriberShopData>(slugKey, fetcher, {
    revalidateOnFocus: false,
  });
};
